import React from 'react';
import { HeroSection } from '../components/lp1-bonus/HeroSection';
import { ProblemSection } from '../components/lp1-bonus/ProblemSection';
import { TruthSection } from '../components/lp1-bonus/TruthSection';
import { ProductIntro } from '../components/lp1-bonus/ProductIntro';
import { MechanismSection } from '../components/lp1-bonus/MechanismSection';
import { WhyFailedSection } from '../components/lp1-bonus/WhyFailedSection';
import { WhatYouGetSection } from '../components/lp1-bonus/WhatYouGetSection';
import { WhoForSection } from '../components/lp1-bonus/WhoForSection';
import { TransformSection } from '../components/lp1-bonus/TransformSection';
import { PricingCTA } from '../components/lp1-bonus/PricingCTA';
import { Footer } from '../components/lp1-bonus/Footer';
export function Lp1BonusPage() {
  return <div className="min-h-screen w-full bg-deep" data-id="element-547">
      <HeroSection data-id="element-548" />
      <ProblemSection data-id="element-549" />
      <TruthSection data-id="element-550" />
      <ProductIntro data-id="element-551" />
      <MechanismSection data-id="element-552" />
      <WhyFailedSection data-id="element-553" />
      <WhatYouGetSection data-id="element-554" />
      <WhoForSection data-id="element-555" />
      <TransformSection data-id="element-556" />
      <PricingCTA data-id="element-557" />
      <Footer data-id="element-558" />
    </div>;
}